import { sf_saleset_register_type } from '../../models/response/dich-vu/sf_saleset_register_type';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_SALESET_REGISTER_TYPE_PATH = "saleset-register-type";

class SaleSetRegisterTypeApi extends BaseCRUDApi<sf_saleset_register_type> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByHocSinh(ts_hocsinh_id: number) {
		return apiClient.get(`${API_SALESET_REGISTER_TYPE_PATH}/select-by-hs/${ts_hocsinh_id}`);
	}
}
export const saleSetRegisterTypeApi = new SaleSetRegisterTypeApi(API_SALESET_REGISTER_TYPE_PATH);
